export enum OrderArticleTrackingDefectStation {
  SORT = 'SORT',
  WASHING = 'WASHING',
  DRYING = 'DRYING',
  IRONING_KANE = 'IRONING_KANE',
  IRONING_ELECTROLUX = 'IRONING_ELECTROLUX',
  IRONING_MACPI = 'IRONING_MACPI',
  FOLDING = 'FOLDING',
  PTL_IN = 'PTL_IN',
  PTL_OUT = 'PTL_OUT',
  CONTROL = 'CONTROL',
  PACKAGING = 'PACKAGING',
}
